<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout row wrap align-center style="margin-top:0px;">
            <v-card style="margin-left:400px">
              <v-btn class="primary" v-on:click="sho1()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">In-Bound Delivery</v-btn>
              <v-btn v-on:click="sho2() && activate(1)" :class="{ active_el : active_el == 1 }" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px;color: #ffffff">Out-Bound Delivery</v-btn>
            </v-card>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs12>
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-card style="margin-top:20px">
              <v-card-text>
                <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Out-Bound Delivery</h3>
                </v-layout>
                <v-divider divider: true style="margin-bottom: 50px"></v-divider>
                <v-flex style="margin-left:20px">
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Out Challan No</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:10px">
                      <v-overflow-btn
                        :items="outchallanno"
                        label="Please Mention"
                        target="#dropdown-example"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Vehicle No</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:10px">
                      <v-overflow-btn
                        :items="vehicleno"
                        label="Please Mention"
                        target="#dropdown-example"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Delivery Date</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        :return-value.sync="date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        style="margin-left:20px"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="date"
                        label="Select Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                      </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:30px">
                      <label>Delivery Time</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-text-field
                        v-model="deliverytime"
                        label=""
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <h3 style="text-align:left;margin-bottom: 10px;margin-left:20px;margin-top: 20px">Received Shipment Details</h3>
                  </v-layout>
                  <v-layout row wrap>
                      <v-flex xs2 style="margin-top:20px;margin-left:20px">
                        <label>Docket No</label>
                        <v-overflow-btn
                          :items="docketno"
                          label="Please Mention"
                          target="#dropdown-example"
                          outline
                          style="margin-top:20px"
                        ></v-overflow-btn>
                      </v-flex>
                      <v-flex xs2 style="margin-top:20px;margin-left:20px">
                        <label>Delivery Status</label>
                        <v-overflow-btn
                          :items="deliverystatus"
                          label="Please Mention"
                          target="#dropdown-example"
                          outline
                          style="margin-top:20px"
                        ></v-overflow-btn>
                      </v-flex>
                      <v-flex xs2 style="margin-top:20px;margin-left:20px">
                        <label>Received By</label>
                        <v-text-field
                          v-model="receivedby"
                          label=""
                          outline
                          style="margin-top:20px"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 style="margin-top:20px;margin-left:20px">
                        <label>Relation with Addressee</label>
                        <v-overflow-btn
                          :items="relation"
                          label="Please Mention"
                          target="#dropdown-example"
                          outline
                          style="margin-top:20px"
                        ></v-overflow-btn>
                      </v-flex>
                      <v-flex xs2 style="margin-top:20px;margin-left:20px">
                        <label>Comment</label>
                        <v-textarea
                          v-model="comment"
                          label=""
                          outline
                          style="margin-top:20px"
                        ></v-textarea>
                      </v-flex>
                  </v-layout>
                  <v-btn flat style="margin-left:-850px;" v-on:click="addnew()">+ Add New</v-btn>
                </v-flex>
                <v-btn class="primary" style="margin-left:20px;" v-on:click="submit()">Submit</v-btn>
                <v-btn class="default" style="margin-left:20px;">Reset</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      outchallanno: [],
      vehicleno: [],
      menu: false,
      date: new Date().toISOString().substr(0, 10),
      deliverytime: '',
      docketno: [],
      deliverystatus: ['Delivered To Customer', 'Delivery Attempted (Failed)'],
      receivedby: '',
      relation: ['Self', 'Brother', 'Sister', 'Wife', 'Father', 'Mother'],
      comment: ''
    }
  },
  methods: {
    submit () {
    },
    sho1 () {
      this.$router.push('/Transportationinbounddelivery')
    },
    sho2 () {
      this.$router.push('/Transportationoutbounddelivery')
    },
    activate: function (el) {
      this.active_el = el
    }
  }
}
</script>
<style>
  .active_el {
    background-color: #00C853
  }
</style>



// WEBPACK FOOTER //
// src/components/Transportationoutbounddelivery.vue